<mat-card-title>
	Counts Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'CountsReport_Overview'"></help-text-btn>
</mat-card-title>
<mat-divider> </mat-divider>
<br>
<div class="row">
	<mat-card appearance="outlined" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
		<mat-card-header>
			<mat-card-title>
				Search Criteria
			</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="lstSelectedRegion" [reset]="resetField"
				#appRegionCode>
			</region-dropdown-two-way>

			<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="lstSelecteddistricts"
				[reset]="resetField" #appSelectedSchoolDistricts [regions]="lstSelectedRegion">
			</district-dropdown-two-way>

			<app-school-year [yearType]="'PerformancePeriod'" (performancePeriodEvent)="performancePeriodEvent($event)"
				[required]="true">
			</app-school-year>
		</mat-card-content>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="isLoadingResults" (click)="search()"
				class="margin-right-xs">
				<mat-icon *ngIf="isLoadingResults">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button class="margin-right-xs" mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>



			<button [disabled]="!(dataSourceStudentEligibilities.data.length > 0) || isExporting || isLoadingResults"
				mat-raised-button [matMenuTriggerFor]="menu" class="margin-right-xs">
				<mat-icon *ngIf="isExporting">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Export
				<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadExcel()">
					<span>
						<i class="fa fa-file"></i>
						Export to Excel</span>
				</button>
				<button mat-menu-item (click)="downloadExcelStudents()">
					<span>
						<i class="fa fa-file"></i>
						Regional Student List (Cat I and Cat II) to Excel</span>
				</button>
			</mat-menu>
		</mat-card-actions>
	</mat-card>
</div>

<!-- counts by  ALL Regions-->
<div class="table-responsive" *ngIf="dataSourceStudentEligibilities.data.length>0 ">
	<div style="padding-top:30px" class="mat-h1">
		Unduplicated Total (All Regions) ({{this.selectedPerformancePeriod}})
		<help-text-btn class="align-help-text-btn" [helpTextId]="'CountsReport_UnduplicatedTotal'"></help-text-btn>

	</div>


	<mat-table [dataSource]="dataSourceStudentEligibilities" class="mat-elevation-z8 table-responsive">
		<ng-container matColumnDef="CODE">
			<mat-header-cell *matHeaderCellDef> {{this.selectedPerformancePeriod}} </mat-header-cell>
			<mat-cell *matCellDef="let element">Unduplicated Total </mat-cell>
		</ng-container>


		<ng-container matColumnDef="EIP">
			<mat-header-cell *matHeaderCellDef [matTooltip]="eligibilityCategoryTypes['EIP']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> EIP
			</mat-header-cell>
			<mat-cell *matCellDef="let element"> {{element.EIP}} </mat-cell>
		</ng-container>


		<ng-container matColumnDef="EC1">
			<mat-header-cell *matHeaderCellDef [matTooltip]="eligibilityCategoryTypes['EC1']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT I </mat-header-cell>
			<mat-cell *matCellDef="let element"> {{element.EC1 }} </mat-cell>
		</ng-container>


		<ng-container matColumnDef="EC2">
			<mat-header-cell *matHeaderCellDef [matTooltip]="eligibilityCategoryTypes['EC2']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT II </mat-header-cell>
			<mat-cell *matCellDef="let element"> {{element.EC2 }} </mat-cell>
		</ng-container>


		<ng-container matColumnDef="EST">
			<mat-header-cell *matHeaderCellDef [matTooltip]="eligibilityCategoryTypes['EST']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> Eligible Today </mat-header-cell>
			<mat-cell *matCellDef="let element"> {{element.EST }} </mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>
</div>

<!-- Counts by  Regions-->
<div class="table-responsive margin-top-sm"
	*ngIf="this.lstchosenSchoolDistrict?.length == 0 && this.lstchosenSchoolRegion.length > 0">
	<div class="mat-h1">
		Counts By Regions ({{selectedPerformancePeriod}})
		<mat-icon *ngIf="isLoadingResults">
			<mat-spinner diameter="18"> </mat-spinner>
		</mat-icon>
		<span *ngIf="isLoadingResults">
			({{loadingCounter}} / {{lstSelectedRegion.length}})
		</span>
	</div>

	<mat-table [dataSource]="dataSourceSchoolRegion" (matSortChange)="regionSortChange($event)" matSort
		class="mat-elevation-z8">
		<ng-container matColumnDef="CODE">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Region</mat-header-cell>
			<mat-cell *matCellDef="let element" matTooltip={{element.NAME}}> {{element.CODE}} </mat-cell>
			<mat-footer-cell *matFooterCellDef>Total </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EIP">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EIP']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> EIP </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EIP === 0">{{element.EIP | numberComma }}</span>

				<button *ngIf="element.EIP > 0" type="button" mat-button color="primary"
					(click)="openStudentRegionDialog(element, 'EIP')" class="display-text-button">
					<span>{{element.EIP | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EIP',true) | numberComma}} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EC1">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EC1']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT I </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EC1 === 0">{{element.EC1 | numberComma }}</span>

				<button *ngIf="element.EC1 > 0" type="button" mat-button color="primary"
					(click)="openStudentRegionDialog(element, 'EC1')" class="display-text-button">
					<span>{{element.EC1 | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EC1',true) | numberComma}} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EC2">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EC2']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT II </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EC2 === 0">{{element.EC2 | numberComma }}</span>

				<button *ngIf="element.EC2 > 0" type="button" mat-button color="primary"
					(click)="openStudentRegionDialog(element, 'EC2')" class="display-text-button">
					<span>{{element.EC2 | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EC2',true) | numberComma}} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EST">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EST']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> Eligible Today </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EST === 0">{{element.EST | numberComma }}</span>

				<button *ngIf="element.EST > 0" type="button" mat-button color="primary"
					(click)="openStudentRegionDialog(element, 'EST')" class="display-text-button">
					<span>{{element.EST | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EST',true) | numberComma}} </mat-footer-cell>
		</ng-container>

		<ng-container matColumnDef="F-Total">
			<mat-footer-cell *matFooterCellDef>Unduplicated Total</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EIP">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EIP?
				resunduplicatedStudentEligibilities.EIP : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EC1">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EC1?
				resunduplicatedStudentEligibilities.EC1 : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EC2">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EC2?
				resunduplicatedStudentEligibilities.EC2 : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EST">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EST?
				resunduplicatedStudentEligibilities.EST : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>


		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		<mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
		<mat-footer-row *matFooterRowDef="alternateFooter"></mat-footer-row>

	</mat-table>
	<!--<mat-paginator #regionPaginator [disabled]="this.lstchosenSchoolRegion.length<pagingService.paging.pageSize"
		[length]="this.lstchosenSchoolRegion.length" [pageSize]="pagingService.paging.pageSize"
		[pageSizeOptions]="pagingService.paging.pageSizeOption" showFirstLastButtons>
	</mat-paginator> -->
</div>

<!-- counts by school District-->
<div class="table-responsive margin-top-sm" *ngIf="this.lstchosenSchoolDistrict.length > 0">
	<div class="mat-h1">
		Counts By School Districts ({{selectedPerformancePeriod}})
		<mat-icon *ngIf="isLoadingResults">
			<mat-spinner diameter="18"> </mat-spinner>
		</mat-icon>
		<span *ngIf="isLoadingResults">
			({{loadingCounter}} / {{lstSelecteddistricts.length}})
		</span>
	</div>
	<mat-table [dataSource]="dataSourceSchoolDistricts" (matSortChange)="districtSortChange($event)" matSort>
		<ng-container matColumnDef="DISTRICTS">
			<mat-header-cell *matHeaderCellDef mat-sort-header> School District </mat-header-cell>
			<mat-cell *matCellDef="let element"> {{element.DISTRICTS}} </mat-cell>
			<mat-footer-cell *matFooterCellDef>Total </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EIP">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EIP']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> EIP </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EIP === 0">{{element.EIP | numberComma }}</span>

				<button *ngIf="element.EIP > 0" type="button" mat-button color="primary"
					(click)="openStudentSchoolDistrictDialog(element, 'EIP')" class="display-text-button">
					<span>{{element.EIP | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EIP',false) }} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EC1">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EC1']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT I </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EC1 === 0">{{element.EC1 | numberComma }}</span>

				<button *ngIf="element.EC1 > 0" type="button" mat-button color="primary"
					(click)="openStudentSchoolDistrictDialog(element, 'EC1')" class="display-text-button">
					<span>{{element.EC1 | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EC1',false) }} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EC2">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EC2']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> CAT II </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EC2 === 0">{{element.EC2 | numberComma }}</span>

				<button *ngIf="element.EC2 > 0" type="button" mat-button color="primary"
					(click)="openStudentSchoolDistrictDialog(element, 'EC2')" class="display-text-button">
					<span>{{element.EC2 | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EC2',false) }} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="EST">
			<mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="eligibilityCategoryTypes['EST']"
				matTooltipClass="multiline-tooltip" matTooltipPosition="below"> Eligible Today </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<span *ngIf="element.EST === 0">{{element.EST | numberComma }}</span>

				<button *ngIf="element.EST > 0" type="button" mat-button color="primary"
					(click)="openStudentSchoolDistrictDialog(element, 'EST')" class="display-text-button">
					<span>{{element.EST | numberComma }}</span>
				</button>
			</mat-cell>
			<mat-footer-cell *matFooterCellDef> {{getTotal('EST',false) }} </mat-footer-cell>
		</ng-container>


		<ng-container matColumnDef="F-Total">
			<mat-footer-cell *matFooterCellDef>Unduplicated Total</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EIP">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EIP?
				resunduplicatedStudentEligibilities.EIP : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EC1">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EC1?
				resunduplicatedStudentEligibilities.EC1 : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EC2">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EC2?
				resunduplicatedStudentEligibilities.EC2 : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>
		<ng-container matColumnDef="F-EST">
			<mat-footer-cell *matFooterCellDef>{{(resunduplicatedStudentEligibilities?.EST?
				resunduplicatedStudentEligibilities.EST : 0) | numberComma}}
			</mat-footer-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="districtColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: districtColumns;"></mat-row>
		<mat-footer-row *matFooterRowDef="districtColumns;sticky:true"></mat-footer-row>
		<mat-footer-row *matFooterRowDef="alternateFooter"></mat-footer-row>
	</mat-table>
	<!--<mat-paginator #districtPaginator [disabled]="this.lstchosenSchoolDistrict.length<pagingService.paging.pageSize"
		[length]="this.lstchosenSchoolRegion.length" [pageSize]="pagingService.paging.pageSize"
		[pageSizeOptions]="pagingService.paging.pageSizeOption" showFirstLastButtons>
	</mat-paginator>-->
</div>